// extracted by mini-css-extract-plugin
module.exports = {"attachButton":"styles_attachButton__1iarW","attachSection":"styles_attachSection__3NNd0","select":"styles_select__2dRB-"};